import * as React from "react"
const SvgEkoIllusDunk2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 1163 820"
    }}
    viewBox="0 0 1163 820"
    {...props}>
    <style>
      {
        ".pm_st1{opacity:.4;fill:#fff}.pm_st2{stroke-linecap:round;stroke-linejoin:round}.pm_st2,.pm_st3{fill:none;stroke:#2d0e5e;stroke-width:4;stroke-miterlimit:10}.pm_st9{opacity:.2;fill:#2d0e5e}.pm_st16{fill:none;stroke:#2d0e5e;stroke-width:2;stroke-miterlimit:10}.pm_st28{fill:#e4e4ef}.pm_st29,.pm_st30,.pm_st31{stroke:#2d0e5e;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.pm_st29{fill:#ed4848;stroke-linejoin:round}.pm_st30,.pm_st31{fill:none}.pm_st31{stroke-linejoin:round}.pm_st32,.pm_st33{fill:#111616}.pm_st33{stroke-width:1.5}.pm_st33,.pm_st34,.pm_st35{stroke:#111616;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.pm_st34{fill:none;stroke-width:1.5}.pm_st35{fill:#111616}.pm_st36{display:none}.pm_st38{display:inline}.pm_st39{fill:#e0d5b5;stroke:#5b480e;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.pm_st52{fill:#dbdbdb}.pm_st53{fill:#4d4d4d}.pm_st54,.pm_st55{fill:#2e2e8b;stroke:#2e2e8b;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.pm_st55{fill:none;stroke:#4d4d4d}.pm_st61{display:inline;fill:#ddf2ee}.pm_st62{fill:#fff}.pm_st62,.pm_st63{display:inline}.pm_st63,.pm_st71{fill:#a6ac5d}.pm_st72{fill:#c5df8d}.pm_st100,.pm_st97,.pm_st98,.pm_st99{fill:#a7c4db;stroke:#a7c4db;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.pm_st100,.pm_st98,.pm_st99{fill:#072e44;stroke:#072e44}.pm_st100,.pm_st99{fill:#13496d;stroke:#13496d}.pm_st100{fill:none}.pm_st101{fill:#13496d}.pm_st102,.pm_st107{stroke-miterlimit:10}.pm_st102{fill:#c2e6f5;stroke:#c2e6f5;stroke-linecap:round;stroke-linejoin:round}.pm_st107{fill:none;stroke:#a6ac5d;stroke-width:2}.pm_st108{fill:#477c4e}.pm_st123{fill:#ccb99a}.pm_st124{fill:#a58265}.pm_st125{fill:#a17b60}.pm_st126{fill:#845550}.pm_st127{fill:#26662c}.pm_st128{fill:#334724}.pm_st129{fill:#6c5410}.pm_st130{fill:#7ab929}.pm_st131{fill:#efb76b}.pm_st132{fill:#b8753a}.pm_st134{fill:#d4c0a0}"
      }
    </style>
    <g id="pm_Lager_1">
      <path
        d="M938.6 528.2c0-39-98.9-70.5-220.8-70.5S497 489.2 497 528.2c0 7.4 3.5 14.4 10.1 21.1l-4.2.3-25.9-23.4c5.5-5.2 8.5-10.8 8.5-16.7 0-26-58.5-47-130.6-47s-130.6 21-130.6 47 58.5 47 130.6 47h7.9c45.7 0 21.6 14.2 7.7 20.9-26.9 11.4-42.7 25.2-42.7 40.1 0 29.2 60.5 54.2 146.8 64.9 10.6 2.7 3.6 6.6.9 7.9-.3.1-.6.3-.9.4-12 5.3-18.9 11.7-18.9 18.5 0 18.7 51.8 33.8 115.7 33.8s115.7-15.1 115.7-33.8c0-5.7-4.9-11.1-13.5-15.9-.7-.4-1.5-.9-2.5-1.3-.5-.3-1.1-.5-1.6-.8-10.4-5.3-1.2-8.8 7.9-10.8 4.2-.6 8.2-1.3 12.2-1.9 72.1-12.2 120.5-35 120.5-61.1 0-4.6-1.5-9.1-4.4-13.4l-.1-.1c-.4-.6-.8-1.2-1.3-1.8-1.6-2.9-2.5-8.3 10.8-10.6 73.2-11.5 123.5-35.5 123.5-63.3z"
        style={{
          opacity: 0.7,
          fill: "#e0d2fc"
        }}
      />
      <path
        d="m554.9 136.5-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4l-77.8 38.5c-5.2 2.4-10.1 10.4-13.4 18.8l-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2v173.4c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0L551 429.8c23.1-14.1 23.1-25.4 23.1-41.9V168c.1-13.7-7.3-25.7-19.2-31.5z"
        className="pm_st28"
      />
      <path d="m395.2 204.5 27.1-15.5" className="pm_st3" />
      <path
        d="m422.3 189-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="pm_st2"
      />
      <path
        d="m542.8 183.4-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        className="pm_st9"
      />
      <path
        d="m488.7 272.6-72.9 97.5 72.9 57.3 72.9-98.2z"
        className="pm_st1"
      />
      <path
        d="M418 206.3c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6v219.9c0 16.5 0 27.8-23.1 41.9l-128.3 72.9c-14.1 8-31.4 8-45.6 0l-34.3-19.6c-14.3-8.2-23.1-23.4-23.1-39.9V269.8c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="pm_st2"
      />
      <path
        d="m542.8 183.4-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        className="pm_st16"
      />
      <path
        d="M365.4 235.1c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9s28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="pm_st29"
      />
      <path
        d="M367.8 250.3c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="pm_st30"
      />
      <path
        d="M409.4 497.3c-9.5 3.5-9.5-3.4-9.5-3.4V309c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        className="pm_st31"
      />
      <path
        d="m489.8 281.1 63.4 49.3-65.7 88.5-63.4-49.9 65.7-87.9m-1.1-8.5-72.9 97.5 72.9 57.3 72.9-98.2-72.9-56.6z"
        className="pm_st32"
      />
      <path
        d="M462.8 383s6.8-5.7 8-7 3-3.8 3-3.8v-22.3s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6-1 .5-3 2.5-3.2 2.6-.2.1-1.5-.6-1.4-.8s1.8-2.7 5.5-4.6c3.7-1.9 6.5-.6 7.1-.6.7 0 1.7.3 2.1-.2.4-.5-.2-4.1-1.3-5.3-1.1-1.2-5.5-2.4-6.6-3.3-1.1-.8-2.9-1.4-3.7-1.4-.8-.1-1.5-.4-1.5-.7 0-.2.7-1.1.9-1.2.2-.1 3.4.2 3.9.6.5.3 2.4 1.6 3.7 1.5 1.3-.1 2.2-.1 2.4-.4.2-.3-.1-6.7-1.1-8.8s-2.7-4.1-3.6-4.4c-.9-.3-1.1-1-.9-1.3s.7-1 .7-1.1.5 0 .7.2c.2.3 1.9 1.3 2.6 1.6.6.3 1.6 1.6 2.1 2.6.5.9.5 1.6.8 1.5.3-.1 1-3.5 1.1-4.1.1-.7.4-2.5.7-2.9.4-.3.5-.5.7-.8.1-.2.4.3.4 1.6s-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3.8 1.7 1.2 3.9 1.3 4.5.2.6.9 2.2 1.6 1.8.7-.3 2.7-5.2 3.2-6.2s1.9-3.2 1.6-5.3c-.2-2.2-.5-11.8-.8-12.7s-.6-3.7-.5-4c.1-.3 1-.8 1.3-1 .4-.2.8 0 .9.7.1.6.9 5.9.8 7.5 0 1.6.1 3.2.3 3s3.1-4.5 3.4-5.2c.3-.7 3-5.6 3.3-6.7.3-1.1 1.3-3.3 1.5-3.5.2-.2 1.1-.3 1.1.3s-1 3.3-1.5 4.4c-.5 1.1-1.8 4.1-2.3 5s-2.4 3.7-3 4.6-1.8 2.9-1.8 2.9.4 4.7.1 6.1-1.5 5.1-2 6.2-.9 2.6-.7 2.5 3.2-5 4.1-5.7 5-2.2 6.2-3.7 5-7.6 5.4-8.5c.4-1 2.3-4 2.5-4.4.3-.4.5.1.6.2.1.2-.8 2.8-1 3.6s-3.9 8-4.4 8.7-1.5 2.5-2.8 3.3-3.5 2-4.5 3.7c-1.1 1.8-6.3 9.8-6.3 10 0 .2.1 15.7.2 16 .2.3 5.3 1.6 9.6 1.1 0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9-1.2.2-2.8.8-3.5 1.2-.7.4-2.6 1.5-3.6 4.4-1 2.9-1.9 5.6-2.1 5.8s-.9-1.3-1.1-1.8c-.2-.5-1.7-1.4-3.1-.6-1.4.9-3.4 1.8-4.1 2.5-.8.7-1.7 1.7-2.8 2.2s-3.3 2.2-5 2.7z"
        className="pm_st33"
      />
      <path
        d="M498.9 372.4s8.4-11.3 16.4-20.3 12.9-13.1 14.8-10.6c1.9 2.5-3.7 10.7-7.5 13.9-3.8 3.2-17.1 13.7-23.7 17z"
        className="pm_st34"
      />
      <path
        d="M528.6 348.1c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M503.4 366.4s.1-4.2-4.8-3.3-7.3 6.3-7.6 7.2c-.3.9-1.7 5.1-1.8 6.1"
        className="pm_st34"
      />
      <path
        d="M491.1 376.2s-3.3.6-5.3 1.8c-2 1.2-5.2 2.5-5.7 2.5 0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7 3.7 5.1 7.1 2.6c3.4-2.4 3.5-6 3.5-6s4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="pm_st34"
      />
      <path
        d="m486 384.3-3.6 1.4-6.2-3.1M485.5 386.4l-2.2 2.5s-5.5-1.7-6.8-2M492.4 370.8s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M489.5 375.1s-3.5-.1-4.2-.5c-.7-.4-2.1-2.3-2.1-2.3M496.8 366.6s-.2-8.3-.8-9.1-3.8-2.3-3.8-2.3M503.4 355.7s-.6-12.2-1.3-13.1c-.7-.8-2.8-3.3-2.8-3.3"
        className="pm_st34"
      />
      <path
        d="M498.1 363.2s3.3-7.5 4.1-10.2c.8-2.7 2-7.6 4.2-11.3 2.3-3.7 5-8.6 5-8.6"
        className="pm_st34"
      />
      <path
        d="M511.2 332.7s4.2 2.1 5.2 4.9c1 2.7 2 9.9-2 15.6"
        className="pm_st34"
      />
      <path
        d="M513.3 354.4s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM516.5 338.1s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="pm_st35"
      />
      <path
        d="M501.3 355.5s-1.7-6.9-2.1-7.5-2.9-2.5-2.9-2.5M493.5 366.2s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="pm_st34"
      />
      <path
        d="M487.4 380.8s4.5-2.1 3.4 1.1-3.4-1.1-3.4-1.1zM499.6 359.6s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7H499l-.5-.8 1.1-2.6z"
        className="pm_st35"
      />
      <path
        d="M372.5 222.8c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9s-10.8-10.9-24.1-10.9-24.1 4.9-24.1 10.9v20.7c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="pm_st29"
      />
      <path
        d="M382 232.3v13.9M391.9 233.7v12.5M400 232.3v13.3M407.4 229.7v13.4"
        className="pm_st30"
      />
      <path
        d="m670.3 217.1-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4L551 250.9c-5.2 2.4-10.1 10.4-13.4 18.8l-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2v173.4c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0l128.3-72.9c23.1-14.1 23.1-25.4 23.1-41.9V248.6c.1-13.7-7.2-25.7-19.2-31.5z"
        className="pm_st28"
      />
      <path d="m510.6 285.1 27.1-15.5" className="pm_st3" />
      <path
        d="m537.7 269.6-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="pm_st2"
      />
      <path
        d="m658.2 264-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1.1 9 1.6 15.4-12.1 23.5z"
        className="pm_st9"
      />
      <path
        d="m604.1 353.2-72.9 97.5 72.9 57.3 72.9-98.2z"
        className="pm_st1"
      />
      <path
        d="M533.4 286.9c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6v219.9c0 16.5 0 27.8-23.1 41.9l-128.3 72.9c-14.1 8-31.4 8-45.6 0l-34.3-19.6c-14.3-8.2-23.1-23.4-23.1-39.9V350.4c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="pm_st2"
      />
      <path
        d="m658.2 264-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1.1 9 1.6 15.4-12.1 23.5z"
        className="pm_st16"
      />
      <path
        d="M480.8 315.7c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9s28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="pm_st29"
      />
      <path
        d="M483.3 330.9c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="pm_st30"
      />
      <path
        d="M524.8 577.9c-9.5 3.5-9.5-3.4-9.5-3.4V389.6c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        className="pm_st31"
      />
      <path
        d="m605.3 361.7 63.4 49.3-65.7 88.5-63.4-49.9 65.7-87.9m-1.2-8.5-72.9 97.5 72.9 57.3 72.9-98.2-72.9-56.6z"
        className="pm_st32"
      />
      <path
        d="M578.2 463.6s6.8-5.7 8-7c1.1-1.3 3-3.8 3-3.8v-22.3s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6-1 .5-3 2.5-3.2 2.6s-1.5-.6-1.4-.8c.1-.2 1.8-2.7 5.5-4.6 3.7-1.9 6.5-.6 7.1-.6.7 0 1.7.3 2.1-.2.4-.5-.2-4.1-1.3-5.3-1.1-1.2-5.5-2.4-6.6-3.3s-2.9-1.4-3.7-1.4-1.5-.4-1.5-.7c0-.2.7-1.1.9-1.2.2-.1 3.4.2 3.9.6.5.3 2.4 1.6 3.7 1.5 1.3-.1 2.2-.1 2.4-.4.2-.3-.1-6.7-1.1-8.8-1-2.1-2.7-4.1-3.6-4.4-.9-.3-1.1-1-.9-1.3.2-.3.7-1 .7-1.1s.5 0 .7.2c.2.3 1.9 1.3 2.6 1.6.6.3 1.6 1.6 2.1 2.6.5.9.5 1.6.8 1.5.3-.1 1-3.5 1.1-4.1.1-.7.4-2.5.7-2.9.4-.3.5-.5.7-.8.1-.2.4.3.4 1.6s-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3.8 1.7 1.2 3.9 1.3 4.5.2.6.9 2.2 1.6 1.8.7-.3 2.7-5.2 3.2-6.2s1.9-3.2 1.6-5.3c-.2-2.2-.5-11.8-.8-12.7s-.6-3.7-.5-4c.1-.3 1-.8 1.3-1s.8 0 .9.7c.1.6.9 5.9.8 7.5 0 1.6.1 3.2.3 3 .2-.2 3.1-4.5 3.4-5.2.3-.7 3-5.6 3.3-6.7.3-1.1 1.3-3.3 1.5-3.5.2-.2 1.1-.3 1.1.3s-1 3.3-1.5 4.4c-.5 1.1-1.8 4.1-2.3 5s-2.4 3.7-3 4.6c-.6.8-1.8 2.9-1.8 2.9s.4 4.7.1 6.1c-.2 1.4-1.5 5.1-2 6.2s-.9 2.6-.7 2.5c.2-.1 3.2-5 4.1-5.7s5-2.2 6.2-3.7c1.2-1.5 5-7.6 5.4-8.5.4-1 2.3-4 2.5-4.4.3-.4.5.1.6.2s-.8 2.8-1 3.6c-.2.8-3.9 8-4.4 8.7s-1.5 2.5-2.8 3.3-3.5 2-4.5 3.7c-1.1 1.8-6.3 9.8-6.3 10 0 .2.1 15.7.2 16s5.3 1.6 9.6 1.1c0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9s-2.8.8-3.5 1.2c-.7.4-2.6 1.5-3.6 4.4-1 2.9-1.9 5.6-2.1 5.8-.2.2-.9-1.3-1.1-1.8-.2-.5-1.7-1.4-3.1-.6-1.4.9-3.4 1.8-4.1 2.5-.8.7-1.7 1.7-2.8 2.2-.7.4-3.3 2.3-5 2.7z"
        className="pm_st33"
      />
      <path
        d="M614.3 453s8.4-11.3 16.4-20.3c8-9 12.9-13.1 14.8-10.6 1.9 2.5-3.7 10.7-7.5 13.9-3.8 3.2-17.1 13.7-23.7 17z"
        className="pm_st34"
      />
      <path
        d="M644 428.7c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M618.9 447s.1-4.2-4.8-3.3c-4.9.8-7.3 6.3-7.6 7.2-.3.9-1.7 5.1-1.8 6.1"
        className="pm_st34"
      />
      <path
        d="M606.6 456.8s-3.3.6-5.3 1.8-5.2 2.5-5.7 2.5c0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7 3.7 5.1 7.1 2.6 3.5-6 3.5-6 4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="pm_st34"
      />
      <path
        d="m601.4 464.9-3.6 1.4-6.1-3.1M600.9 467l-2.2 2.5s-5.5-1.7-6.8-2M607.8 451.4s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M604.9 455.7s-3.5-.1-4.2-.5c-.7-.4-2.1-2.3-2.1-2.3M612.2 447.2s-.2-8.3-.8-9.1c-.6-.9-3.8-2.3-3.8-2.3M618.8 436.3s-.6-12.2-1.3-13.1c-.7-.8-2.8-3.3-2.8-3.3"
        className="pm_st34"
      />
      <path
        d="M613.5 443.8s3.3-7.5 4.1-10.2 2-7.6 4.2-11.3c2.3-3.7 5-8.6 5-8.6"
        className="pm_st34"
      />
      <path
        d="M626.6 413.3s4.2 2.1 5.2 4.9c1 2.7 2 9.9-2 15.6"
        className="pm_st34"
      />
      <path
        d="M628.7 435s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM631.9 418.7s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="pm_st35"
      />
      <path
        d="M616.8 436.1s-1.7-6.9-2.1-7.5c-.4-.5-2.9-2.5-2.9-2.5M608.9 446.8s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="pm_st34"
      />
      <path
        d="M602.8 461.4s4.5-2.1 3.4 1.1-3.4-1.1-3.4-1.1zM615.1 440.3s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7h-1.8l-.5-.8 1-2.6z"
        className="pm_st35"
      />
      <path
        d="M487.9 303.4c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9s-10.8-10.9-24.1-10.9-24.1 4.9-24.1 10.9v20.7c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="pm_st29"
      />
      <path
        d="M497.4 312.9v13.9M507.3 314.3v12.5M515.4 312.9v13.3M522.8 310.4v13.3"
        className="pm_st30"
      />
      <path
        d="m784.9 297.6-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4l-77.8 38.5c-5.2 2.4-10.1 10.4-13.4 18.8l-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2v173.4c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0L781 590.9c23.1-14.1 23.1-25.4 23.1-41.9V329.1c.1-13.7-7.2-25.7-19.2-31.5z"
        className="pm_st28"
      />
      <path d="m625.2 365.6 27.1-15.5" className="pm_st3" />
      <path
        d="m652.3 350.1-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="pm_st2"
      />
      <path
        d="M772.9 344.5 692 385.4c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        className="pm_st9"
      />
      <path
        d="m718.8 433.7-72.9 97.5 72.9 57.3 72.9-98.2z"
        className="pm_st1"
      />
      <path
        d="M648.1 367.4c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6V549c0 16.5 0 27.8-23.1 41.9l-128.3 72.9c-14.1 8-31.4 8-45.6 0L573 644.1c-14.3-8.2-23.1-23.4-23.1-39.9V430.9c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="pm_st2"
      />
      <path
        d="M772.9 344.5 692 385.4c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        className="pm_st16"
      />
      <path
        d="M595.4 396.2c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9s28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="pm_st29"
      />
      <path
        d="M597.9 411.4c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="pm_st30"
      />
      <path
        d="M639.5 658.4c-9.5 3.5-9.5-3.4-9.5-3.4V470.1c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        className="pm_st31"
      />
      <path
        d="m719.9 442.1 63.4 49.3-65.7 88.5-63.4-49.9 65.7-87.9m-1.1-8.4-72.9 97.5 72.9 57.3 72.9-98.2-72.9-56.6z"
        className="pm_st32"
      />
      <path
        d="M692.8 544s6.8-5.7 8-7c1.1-1.3 3-3.8 3-3.8v-22.3s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6-1 .5-3 2.5-3.2 2.6-.2.1-1.5-.6-1.4-.8.1-.2 1.8-2.7 5.5-4.6s6.5-.6 7.1-.6c.7 0 1.7.3 2.1-.2s-.2-4.1-1.3-5.3c-1.1-1.2-5.5-2.4-6.6-3.3-1.1-.8-2.9-1.4-3.7-1.4-.8-.1-1.5-.4-1.5-.7 0-.2.7-1.1.9-1.2.2-.1 3.4.2 3.9.6.5.3 2.4 1.6 3.7 1.5 1.3-.1 2.2-.1 2.4-.4.2-.3-.1-6.7-1.1-8.8-1-2.1-2.7-4.1-3.6-4.4s-1.1-1-.9-1.3c.2-.3.7-1 .7-1.1 0-.1.5 0 .7.2.2.3 1.9 1.3 2.6 1.6.6.3 1.6 1.6 2.1 2.6.5.9.5 1.6.8 1.5s1-3.5 1.1-4.1c.1-.7.4-2.5.7-2.9.4-.3.5-.5.7-.8.1-.2.4.3.4 1.6s-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3.8 1.7 1.2 3.9 1.3 4.5.2.6.9 2.2 1.6 1.8s2.7-5.2 3.2-6.2 1.9-3.2 1.6-5.3-.5-11.8-.8-12.7c-.3-.9-.6-3.7-.5-4s1-.8 1.3-1c.4-.2.8 0 .9.7.1.6.9 5.9.8 7.5 0 1.6.1 3.2.3 3 .2-.2 3.1-4.5 3.4-5.2.3-.7 3-5.6 3.3-6.7s1.3-3.3 1.5-3.5 1.1-.3 1.1.3-1 3.3-1.5 4.4c-.5 1.1-1.8 4.1-2.3 5s-2.4 3.7-3 4.6c-.6.8-1.8 2.9-1.8 2.9s.4 4.7.1 6.1-1.5 5.1-2 6.2c-.4 1.1-.9 2.6-.7 2.5s3.2-5 4.1-5.7c.9-.7 5-2.2 6.2-3.7 1.2-1.5 5-7.6 5.4-8.5.4-1 2.3-4 2.5-4.4.3-.4.5.1.6.2.1.2-.8 2.8-1 3.6s-3.9 8-4.4 8.7c-.5.8-1.5 2.5-2.8 3.3-1.3.8-3.5 2-4.5 3.7s-6.3 9.8-6.3 10c0 .2.1 15.7.2 16 .2.3 5.3 1.6 9.6 1.1 0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9-1.2.2-2.8.8-3.5 1.2-.7.4-2.6 1.5-3.6 4.4s-1.9 5.6-2.1 5.8c-.2.2-.9-1.3-1.1-1.8-.2-.5-1.7-1.4-3.1-.6-1.4.9-3.4 1.8-4.1 2.5-.8.7-1.7 1.7-2.8 2.2-.7.4-3.3 2.3-5 2.7z"
        className="pm_st33"
      />
      <path
        d="M728.9 533.5s8.4-11.3 16.4-20.3c8-9 12.9-13.1 14.8-10.6 1.9 2.5-3.7 10.7-7.5 13.9s-17 13.7-23.7 17z"
        className="pm_st34"
      />
      <path
        d="M758.7 509.1c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M733.5 527.5s.1-4.2-4.8-3.3-7.3 6.3-7.6 7.2c-.3.9-1.7 5.1-1.8 6.1"
        className="pm_st34"
      />
      <path
        d="M721.2 537.3s-3.3.6-5.3 1.8-5.2 2.5-5.7 2.5c0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7 3.7 5.1 7.1 2.6c3.4-2.4 3.5-6 3.5-6s4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="pm_st34"
      />
      <path
        d="m716 545.4-3.5 1.4-6.2-3.1M715.5 547.5l-2.2 2.5s-5.5-1.7-6.8-2M722.4 531.9s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M719.5 536.1s-3.5-.1-4.2-.5c-.7-.4-2.1-2.3-2.1-2.3M726.8 527.6s-.2-8.3-.8-9.1-3.8-2.3-3.8-2.3M733.4 516.8s-.6-12.2-1.3-13.1c-.7-.8-2.8-3.3-2.8-3.3"
        className="pm_st34"
      />
      <path
        d="M728.2 524.3s3.3-7.5 4.1-10.2c.8-2.7 2-7.6 4.2-11.3s5-8.6 5-8.6"
        className="pm_st34"
      />
      <path
        d="M741.2 493.7s4.2 2.1 5.2 4.9c1 2.7 2 9.9-2 15.6"
        className="pm_st34"
      />
      <path
        d="M743.3 515.5s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM746.6 499.2s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="pm_st35"
      />
      <path
        d="M731.4 516.6s-1.7-6.9-2.1-7.5-2.9-2.5-2.9-2.5M723.5 527.3s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="pm_st34"
      />
      <path
        d="M717.4 541.9s4.5-2.1 3.4 1.1-3.4-1.1-3.4-1.1zM729.7 520.7s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7h-1.8l-.5-.8 1-2.6z"
        className="pm_st35"
      />
      <path
        d="M602.5 383.9c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9s-10.8-10.9-24.1-10.9-24.1 4.9-24.1 10.9v20.7c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="pm_st29"
      />
      <path
        d="M612 393.4v13.8M621.9 394.8v12.4M630 393.4v13.3M637.5 390.8v13.4"
        className="pm_st30"
      />
    </g>
  </svg>
)
export default SvgEkoIllusDunk2
